import { redirect } from "react-router-dom";
import { RouterPath } from "@/router/types";

export const loginLoader = () => {
  const token = localStorage.getItem("token");
  if (token) {
    return redirect(RouterPath.Cabinet);
  }
  return null;
};
